import React, { Component } from 'react';
import { Redirect } from 'react-router';
import './login.css';
import LoadMask from '../../Utils/LoadMask/LoadMask';
import LoginForm from './LoginForm';

class Login extends Component {
    render() {
        const { onSubmit, loader } = this.props;
        if (localStorage.getItem('token')) {
            return (<Redirect to="/" />);
        }
        return (
            <React.Fragment>
                <span style={{position: 'absolute', color: 'white', right: 10, top: 10}}>HULERAX v1</span>
                <div className="bg-image"></div>
                <section className="bg-content">
                    <img src={require('assets/img/logo blanco.png')} width="15%" alt="" className="mb-5" />
                    <div className="col-3">
                        <LoadMask loading={loader} light>
                            <LoginForm onSubmit={onSubmit} id="loginForm"/>
                        </LoadMask>
                    </div>
                </section>

            </React.Fragment>
        )
    }
}

export default Login;
